import "./ConsentPrivacySkeleton.scss";

export const ConsentPrivacySkeleton = () => {
  return (
    <div className="consent-skeleton-container">
      {/* Header with title and save button */}
      <div className="consent-skeleton-header">
        <div className="consent-skeleton-title pulse"></div>
        <div className="consent-skeleton-save-button pulse"></div>
      </div>

      <div className="consent-skeleton-divider"></div>

      {/* Description text */}
      <div className="consent-skeleton-description">
        <div className="consent-skeleton-paragraph pulse"></div>
      </div>

      <div className="consent-skeleton-paragraph-small pulse"></div>

      {/* Consent items */}
      <div className="consent-skeleton-items">
        {/* Consent item 1 */}
        <div className="consent-skeleton-item">
          <div className="consent-skeleton-item-content">
            <div className="consent-skeleton-item-title pulse"></div>
          </div>
          <div className="consent-skeleton-item-button pulse"></div>
        </div>

        {/* Consent item 2 */}
        <div className="consent-skeleton-item">
          <div className="consent-skeleton-item-content">
            <div className="consent-skeleton-item-title pulse"></div>
          </div>
          <div className="consent-skeleton-item-button pulse"></div>
        </div>

        {/* Consent item 3 - with longer title */}
        <div className="consent-skeleton-item">
          <div className="consent-skeleton-item-content">
            <div className="consent-skeleton-item-title-long pulse"></div>
            <div className="consent-skeleton-item-title-long pulse"></div>
          </div>
          <div className="consent-skeleton-item-button pulse"></div>
        </div>

        {/* Consent item 4 */}
        <div className="consent-skeleton-item">
          <div className="consent-skeleton-item-content">
            <div className="consent-skeleton-item-title pulse"></div>
          </div>
          <div className="consent-skeleton-item-button pulse"></div>
        </div>
      </div>

      {/* Privacy note */}
      <div className="consent-skeleton-privacy-note">
        <div className="consent-skeleton-icon pulse"></div>
        <div className="consent-skeleton-note-content">
          <div className="consent-skeleton-note-text pulse"></div>
          <div className="consent-skeleton-note-text pulse"></div>
          <div className="consent-skeleton-privacy-link pulse"></div>
        </div>
      </div>
    </div>
  );
};
